<template>
  <div class="quote-request">
    <v-dialog v-model="dialog" max-width="450" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">Send Request</h3>
            <v-icon @click="$emit('close')">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div v-if="dealer" class="text-center">
            <div class="text-center mb-3">
              <strong class="black--text"
                >Send a request for quote to {{ dealer.dealer_company }} Dealer
                ?</strong
              >
            </div>
            <v-autocomplete
              v-model="version"
              :items="versions"
              item-text="number"
              item-value="number"
              dense
              outlined
              label="Select Schedule Version"
            ></v-autocomplete>
            <v-btn
              color="success"
              class="white--text mr-1"
              depressed
              :disabled="version === null"
              :loading="loading"
              @click="sendRequest"
              >Send</v-btn
            >
            <v-btn color="black" outlined depressed @click="$emit('close')"
              >Cancel</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    dealer: {
      type: Object,
      default: null
    }
  },
  created() {
    this.getProjectSchedule();
  },
  methods: {
    getProjectSchedule() {
      const payload = {
        id: this.$route.params.id,
        name: this.$route.params.name
      };

      this.$store
        .dispatch("schedule/getProjectSchedule", payload)
        .then(resp => {
          const schedule = { ...resp.schedule };
          this.versions = [...schedule.versions];

          if (this.versions && this.versions.length > 0) {
            this.version = this.versions[0].number;
          }
        });
    },
    sendRequest() {
      const payload = {
        project_id: this.$route.params.id,
        schedule: this.$route.params.name,
        email: this.dealer.email,
        version: this.version,
        expected_delievery_time: "27 days"
      };

      this.loading = true;
      this.$store
        .dispatch("rfq/sendRFQ", payload)
        .then(() => {
          this.$emit("refresh");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  data() {
    return {
      loading: false,
      versions: [],
      version: null
    };
  }
};
</script>
